<div id="monitorscreen"
     echoNxResizeObserver
     (ngResize)="onScreenResize($event)">

    <ng-content></ng-content>
</div>
